import React from 'react';
import { Glyphicon } from 'react-bootstrap';

import { connect } from 'react-redux';
import { toggleSidebarCollapsed } from '../actions/reduxActions/sidebar';

import '../../css/sidebar.less';

// eslint-disable-next-line import/no-unused-modules
export class Sidebar extends React.Component {

    constructor(props) {
        super(props);
        this.state = { isScrolling: false };
    }

    componentDidMount() {
        this.onResize();
        window.addEventListener('resize', manywho.utils.debounce(this.onResize, 200));
    }

    onResize = () => {
        const itemListElement = this.refs.items;
        this.setState({
            isScrolling: itemListElement ? itemListElement.scrollHeight > itemListElement.clientHeight : false,
        });
    }

    render() {
        let className = 'sidebar';
        if (this.props.class) className += ` ${this.props.class}`;

        const { isCollapsed } = this.props;
        if (isCollapsed) className += ' collapsed';

        if (this.state.isScrolling) className += ' scrolling';

        return (
            <div className={className}>
                <div className="sidebar-inner">
                    <div className="sidebar-collapse" onClick={() => this.props.toggleCollapsed({ isCollapsed })}>
                        {(isCollapsed) ? <Glyphicon glyph="chevron-right" /> : <Glyphicon glyph="chevron-left" />}
                    </div>
                    <ul className="list-unstyled" ref="items">
                        {this.props.children}
                    </ul>
                </div>
            </div>
        );
    }

}

const mapStateToProps = ({
    sidebar: { isCollapsed },
}) => ({ isCollapsed });

const mapDispatchToProps = {
    toggleCollapsed: toggleSidebarCollapsed,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true },
)(Sidebar);
